export enum TraceError {
    AUTH_ERROR = 'AUTH_ERROR',

    KBA_MAX_ATTEMPTS_ERROR = 'KBA_MAX_ATTEMPTS_ERROR',
    KBA_CUSTOMER_BLOCKED = 'KBA_CUSTOMER_BLOCKED',

    OTP_EMAIL_ERROR = 'OTP_MAIL_ERROR',
    OTP_NO_EMAIL_ERROR = 'OTP_MAIL_ERROR',
    OTP_VALIDATION_CODE_ERROR = 'OTP_VALIDATION_CODE_ERROR',

    USER_MAX_ACCOUNTS_ERROR = 'USER_MAX_ACCOUNTS_ERROR',
    USER_BLACKLIST_ERROR = 'USER_BLACKLIST_ERROR',

    EXECUTION_ERROR = 'EXECUTION_ERROR'
  }
